import { AppBar, Grid, Toolbar, Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import MaintenanceActionsTable from './MaintenanceActionsTable';
import MaintenanceBasicInfo from './MaintenanceBasicInfo';

const Height100 = styled.div`
  height: 100%;
`;

const ScrollOverflow = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  padding: 30px;
`;

type Props = {
  title: string;
  subtitle?: string;
  vehicleId?: number;
};

export default function MaintenancePage({ title, subtitle, vehicleId }: Props) {
  return (
    <Grid container direction="column" component={Height100}>
      <AppBar>
        <Toolbar>
          <div>
            <Typography variant="h3">{title}</Typography>
            <Typography variant="subtitle1">
              {vehicleId ? (
                <Link to={`/vehicles/${vehicleId}`}>{subtitle}</Link>
              ) : (
                subtitle
              )}
            </Typography>
          </div>
        </Toolbar>
      </AppBar>
      <Grid component={ScrollOverflow} item xs>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <MaintenanceBasicInfo />
          </Grid>
          <Grid item xs={12}>
            <MaintenanceActionsTable />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
